import { render } from "./FlowCards.vue?vue&type=template&id=6dfc8b3a"
import script from "./FlowCards.vue?vue&type=script&lang=js"
export * from "./FlowCards.vue?vue&type=script&lang=js"
script.render = render

export default script